<!-- <p class="mt-3 text-lg font-bold text-gray-800 max-w-lg">
    API Access</p>
<p class="mt-3 text-md text-gray-800">
    Get access to Genailia Services through the API plan
</p>
<p class="mt-3 text-md text-gray-800">
    If you have subscribed to our API plan, you can access Genailia’s services through the API. 
    The API plan offers various tiers based on the number of minutes, words, and other metrics.
     To get started, review our comprehensive API documentation. 
     Once you're ready, generate an API key from the ‘API Keys’ section below 
     and use it to authenticate your requests to the API.
</p>
<button class="mt-3 mb-5 text-md text-[blue] font-bold" (click)="navigateToDocumentation()" >
    API Documentation
</button>

<div class="grid sm:grid-cols-1 lg:grid-cols-1 gap-6 mb-10 lg:mb-14 max-w-[30rem] w-full">
    <div
        class="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md transition ">
        <div class="p-4 md:p-5">
            <p class="text-md text-gray-800 font-bold">
                Credentials
            </p>
            <form class="w-full mt-3">
           

                <label for="website-admin" class="mt-3 block mb-2 text-sm font-normal text-gray-900 ">
                    Secret Key
                </label>
                <div class="flex">
                    <input type="password" id="website-admin"
                        class="rounded-none rounded-s-md bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
                        placeholder="RXIA8SDV75SDV7UT">
                        <span
                        class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
                            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
                            <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
                          </svg>
                    </span>
                    <span
                    class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-e-lg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-copy" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                    </svg>
                </span>
                </div>
                <button type="submit" class="text-red-500 rounded-md inline-flex items-center justify-center py-2 px-7 mt-3 text-center font-medium"
                style="border:1px solid red">
                    Revoke Secrete Key
                </button>
                
            </form>
        </div>
    </div>
</div> -->
<div [ngClass]="currentTheme === 'dark' ? 'bg-[#1d222b] text-white' : 'bg-white text-black'">
    <div class="max-w-lg p-4 sm:ml-6">
      <h1 class="mb-8 text-xl font-semibold">API Access</h1>
      <div class="space-y-3">
        <p> Get access to Genailia Services through the API plan</p>
        <p>
          If you have subscribed to our API plan, you can access Genailia’s services through the API. 
          The API plan offers various tiers based on the number of minutes, words, and other metrics.
          To get started, review our comprehensive API documentation. 
          Once you're ready, generate an API key from the ‘API Keys’ section below 
          and use it to authenticate your requests to the API.
        </p>
        <p class="text-base leading-10">
          <a
            target="_blank"
            [ngClass]="currentTheme === 'dark' ? 'text-[#2a2ae8c4]' : 'text-[#2a2ae8c4]'"
            class="font-semibold no-underline"
            href="https://documentation.genailia.com/"
            >API Documentation</a
          >
        </p>
      </div>
      <div [ngClass]="currentTheme === 'dark' ? 'bg-[#212631] border-neutral-700' : 'bg-neutral-100 border-neutral-300'" class="rounded-lg border p-3 mt-10">
        <h3 *ngIf="isSecretKey" class="mb-6 text-base font-semibold">Credentials</h3>
        <div class="space-y-5">
          <div *ngIf="isSecretKey" class="max-w-full w-auto">
            <label for="userId" class="mb-2 block">Secret Key</label>
            <p *ngIf="errorMsg" class="text-danger">{{errorMsg}}</p>
            <div class="flex rounded-xl">
              <div class="relative flex flex-grow items-stretch focus-within:z-10">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    class="h-5 w-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  id="userId"
                  name="userId"
                  type="text"
                  disabled
                  [ngClass]="currentTheme === 'dark' ? 'bg-neutral-700 text-white' : 'bg-neutral-200 text-black'"
                  class="block w-full text-ellipsis overflow-hidden ... rounded-l-xl border-0 px-6 py-3 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-neutral-600 last:rounded-xl focus:ring-2 focus:ring-inset focus:ring-gray-400 pl-10"
                  placeholder="Key will be shown here.."
                  value="{{apikeyval}}"
                />
                <button
                  type="button"
                  (click)="copyToClipboard()"
                  [ngClass]="currentTheme === 'dark' ? 'bg-neutral-700 hover:bg-neutral-600 text-white' : 'bg-neutral-200 hover:bg-neutral-100 text-black'"
                  class="relative -ml-px inline-flex items-center gap-x-1.5 px-3 py-2 font-semibold ring-1 ring-inset ring-neutral-600 last:rounded-r-md"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    class="h-5 w-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <button
          *ngIf="!apikeyval"
            [ngClass]="currentTheme === 'dark' ? 'bg-[#333b4b]' : 'bg-[#c2c2c2]'"
            class="flex w-full items-center justify-center gap-2 font-semibold transition-all text-base py-2.5 px-5 rounded-md opacity-100"
            type="button"
                  (click)="genKey()"
          >
            Generate Secret Key
            <span class="mt-1">
              
              <svg data-name="Layer 1" id="Layer_1" width="20px" height="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M460.54,169.58A222.6,222.6,0,1,0,478,256,221.16,221.16,0,0,0,460.54,169.58ZM256,448C150,448,64,362,64,256S150,64,256,64s192,86,192,192S362,448,256,448Zm28.06-307.33L399.39,256,284.06,371.33l-21.21-21.21L342,271H133.82V241H342l-79.12-79.12Z"/></svg>
            </span>
            </button>
            <button
            *ngIf="apikeyval"
            [ngClass]="currentTheme === 'dark' ? 'bg-[#d72b34]' : 'bg-[#d22121] text-white'"
            class="flex w-full items-center justify-center gap-2 font-semibold transition-all text-base py-2.5 px-5 rounded-md opacity-100"
            type="button"
                  (click)="delKey()"
          >
            Revoke Secret Key
         
            </button>
        </div>
      </div>
    </div>
  </div>
  